import type { gsapTimelineFunc } from '../gsap-config';
import { backInDown } from './back-in-down';
import { bounceIn } from './bounce-in';
import { fadeIn } from './fade-in';
import { lightSpeedIn } from './light-speed-in';
import { magicBlock } from './magic-block';
import { movingNeon } from './moving-neon';
import { neon } from './neon';
import { pan } from './pan';
import { rise } from './rise';
import { rotateInA } from './rotate-in-a';
import { rotateInB } from './rotate-in-b';
import { scrapbookA } from './scrapbook-a';
import { scrapbookB } from './scrapbook-b';
import { stomp } from './stomp';
import { swingIn } from './swing-in';
import { tiltIn } from './tilt-in';
import { zoomIn } from './zoom-in';
import { zoomOut } from './zoom-out';

export type AnimationTimeline = gsap.core.Timeline;

export type AnimationType =
  | 'no_animation'
  | 'fade_in'
  | 'bounce_in'
  | 'back_in_down'
  | 'light_speed_in'
  | 'magic_block'
  | 'moving_neon'
  | 'neon'
  | 'pan'
  | 'rise'
  | 'rotate_in_a'
  | 'rotate_in_b'
  | 'scrapbook_a'
  | 'scrapbook_b'
  | 'stomp'
  | 'swing_in'
  | 'tilt_in'
  | 'zoom_in'
  | 'zoom_out';

export const AnimationMap: Record<AnimationType, gsapTimelineFunc | undefined> = {
  no_animation: undefined,
  fade_in: fadeIn,
  bounce_in: bounceIn,
  back_in_down: backInDown,
  light_speed_in: lightSpeedIn,
  magic_block: magicBlock,
  moving_neon: movingNeon,
  neon: neon,
  pan: pan,
  rise: rise,
  rotate_in_a: rotateInA,
  rotate_in_b: rotateInB,
  scrapbook_a: scrapbookA,
  scrapbook_b: scrapbookB,
  stomp: stomp,
  swing_in: swingIn,
  tilt_in: tiltIn,
  zoom_in: zoomIn,
  zoom_out: zoomOut,
};
